export default __webpack_public_path__ + "static/difiLogoBiggerTextPink-34237cf58892bdfeb523696bcf53d3f2.png";